import React from 'react';

import { IPublishedConnectionDetailInfo } from '~src/publishedConnection/models/IPublishedConnectionInfo';

import { PublishedConnectionScheduledTasksView } from './scheduledTasks/PublishedConnectionScheduledTasksView';

export type PublishedConnectionScheduledTasksSubplaceProps = Readonly<{
  editActionsAllowed: boolean;
  isServerOrSiteAdmin: boolean;
  publishedConnectionDetailInfo: IPublishedConnectionDetailInfo;
  updateScheduledTasksCount: () => void;
}>;

export function PublishedConnectionScheduledTasksSubplace(props: PublishedConnectionScheduledTasksSubplaceProps): JSX.Element {
  return (<PublishedConnectionScheduledTasksView {...props}/>);
}
